<template>
    <div class="iframeContainer">
        <div v-if="iframeLoading">
            <md-progress-spinner class="md-accent" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <iframe
            v-if="getCustomerClientAddress()"
            class="mt-2"
            sandbox="allow-forms allow-top-navigation allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-scripts"
            frameborder="0"
            loading="eager"
            :src="getCustomerClientAddress()"
            @load="iframeLoading = false"
        />
        <div class="d-flex justify-content-end mt-1" v-if="!iframeLoading">
            <img
                @click="$bvModal.show('bubble-icon-modal')"
                v-if="getCustomBubbleIcon()"
                alt="bubble"
                :src="getCustomBubbleIcon()"
                style="width: 75px; height: 75px; object-fit: contain"
            />
            <div @click="$bvModal.show('bubble-icon-modal')" v-else>
                <Bubble1
                    v-if="settings.bubble.preDefined === '1'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble2
                    v-if="settings.bubble.preDefined === '2'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble3
                    v-if="settings.bubble.preDefined === '3'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble4
                    v-if="settings.bubble.preDefined === '4'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble5
                    v-if="settings.bubble.preDefined === '5'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble6
                    v-if="settings.bubble.preDefined === '6'"
                    style="width: 75px; height: 75px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble7
                    v-if="settings.bubble.preDefined === '7'"
                    style="width: 155px; height: 50px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
                <Bubble8
                    v-if="settings.bubble.preDefined === '8'"
                    style="width: 155px; height: 50px; object-fit: contain"
                    :color="settings.bubble.bubbleColor"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Bubble1 from "../svg/bubbles/Bubble1";
import Bubble2 from "../svg/bubbles/Bubble2";
import Bubble3 from "../svg/bubbles/Bubble3";
import Bubble4 from "../svg/bubbles/Bubble4";
import Bubble5 from "../svg/bubbles/Bubble5";
import Bubble6 from "../svg/bubbles/Bubble6";
import Bubble7 from "../svg/bubbles/Bubble7";
import Bubble8 from "../svg/bubbles/Bubble8";
import { mapActions, mapState } from "vuex";
import { PRODUCTION } from "../../utils/utils";

export default {
    name: "LivePreview",
    components: {
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
        Bubble8,
    },
    data() {
        return {
            iframeLoading: true,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        getCustomerClientAddress() {
            const customerClientAddress = _.get(this.site, "customerClientAddress");
            if (customerClientAddress && customerClientAddress !== "undefined") {
                const protocol = PRODUCTION ? "https" : "http";
                return `${protocol}://${customerClientAddress}?preview=1`;
            }
        },
        getCustomBubbleIcon() {
            const predefined = _.get(this.settings, "bubble.predefined");
            if (predefined && predefined === "0") {
                let { customIcon } = this.settings.bubble;
                if (this.newIcon || customIcon) {
                    let { path, _id, ext } = this.newIcon || customIcon;
                    return `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
                }
            }

            return undefined;
        },
    },
};
</script>

<style scoped></style>
